// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {kebabCase, map, orderBy, remove} from 'lodash';

// Components
import Button from './button';
import MaximizePanelAction from '../components-app/maximize-panel-action';

// Styles
import './panel-wrapper.scss';

let idCounter = 0;

export default class PanelWrapper extends Component {
    state = {
        panelActions: [],
        registeredId: -1,
    };

    getChildContext() {
        return {
            hidePanel: this.hidePanel,
            getPanelTitle: this.getPanelTitle,
            registerPanelAction: this.registerPanelAction,
            togglePanelMaximize: this.togglePanelMaximize,
            unregisterPanelAction: this.unregisterPanelAction,
        };
    }

    getPanelId() {
        return this.props.node.getId();
    }

    getPanelTitle = () => this.props.node.getName();

    getTabsetId() {
        return this.props.node.getParent().getId();
    }

    hidePanel = () => {
        this.context.hidePanel(this.getPanelId(), true);
    };

    togglePanelMaximize = () => {
        this.context.togglePanelMaximize(this.getTabsetId());
    };

    registerPanelAction = panelAction => {
        const registeredId = ++idCounter;

        this.setState(
            prevState => ({panelActions: [...prevState.panelActions, {...panelAction, registeredId}]}),
            () => {
                this.onChange();
            }
        );

        return registeredId;
    };

    unregisterPanelAction = registeredId => {
        if (registeredId) {
            this.setState(
                prevState => {
                    const panelActions = [...prevState.panelActions];

                    remove(panelActions, action => action.registeredId === registeredId);
                    return {panelActions};
                },
                () => {
                    this.onChange();
                }
            );
        }
    };

    onChange = () => {
        const renderedIcons = {};
        const buttons = [];
        const hotkeys = {};
        map(orderBy(this.state.panelActions, 'weight'), action => {
            if (action.icon && !renderedIcons[action.icon]) {
                renderedIcons[action.icon] = 1;
                buttons.push(this.renderPanelActionButton(action));
            }
            if (action.hotkey) {
                hotkeys[action.hotkey] = this.handleHotkey(action);
            }
        });

        this.props.onChange(this.getPanelId(), buttons, hotkeys);
    };

    togglePanel(registeredId, onClick, event) {
        const accordion = this.refs[`accordion${registeredId}`];

        if (accordion) {
            accordion.togglePanel();
        }

        if (onClick) {
            onClick(event);
        }
    }

    handleActionClick = (registeredId, icon, onClick, event) => {
        if (icon) {
            map(this.state.panelActions, (panel, key) => {
                if (panel.icon === icon) {
                    this.togglePanel(panel.registeredId, panel.onClick, event);
                }
            });
        } else {
            this.togglePanel(registeredId, onClick, event);
        }

        this.props.onClick(this.props.node, this.getPanelId());
    };

    handleHotkey = ({groupByIcon, icon, onClick, registeredId}) => event =>
        this.handleActionClick(registeredId, groupByIcon ? icon : null, onClick, event);

    renderPanelActionButton = ({groupByIcon, hotkey, icon, onClick, registeredId, title}) => {
        const props = {
            className: 'panel-wrapper--action-toggle',
            icon,
            onClick: event => this.handleActionClick(registeredId, icon, onClick, event),
            title: hotkey ? `${title} (${hotkey})` : title,
        };

        return <Button key={registeredId} {...props} />;
    };

    renderActionsContent = () => {
        const {panelActions} = this.state;
        let content = null;

        if (panelActions.length) {
            content = map(panelActions, ({registeredId, renderCallback}, index) => {
                const props = {
                    className: 'panel-wrapper--action-content',
                    detailsRenderer: renderCallback,
                    disableDefaultToggle: true,
                    key: index,
                    ref: `accordion${registeredId}`,
                };

                return renderCallback ? <AccordionPanel {...props} /> : null;
            });
        }

        return content;
    };

    // TODO: Decide if we need to renderActionsContent in this component.
    render() {
        const props = {
            className: 'panel-wrapper',
            id: `panel--${kebabCase(this.props.node.getName())}`,
        };

        return (
            <div {...props}>
                <MaximizePanelAction />
                {/* this.renderActionsContent() */}
                {this.props.children}
            </div>
        );
    }
}

PanelWrapper.propTypes = {
    children: PropTypes.node,
    node: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
};

PanelWrapper.contextTypes = {
    hidePanel: PropTypes.func,
    togglePanelMaximize: PropTypes.func,
};

PanelWrapper.childContextTypes = {
    getPanelTitle: PropTypes.func,
    hidePanel: PropTypes.func,
    togglePanelMaximize: PropTypes.func,
    registerPanelAction: PropTypes.func,
    unregisterPanelAction: PropTypes.func,
};
